import { Controller, useFormContext } from 'react-hook-form'

import { TextField } from '@/shared/components/TextField/TextField'
import { pxToRem } from '@/shared/styles/themes'
import { Grid2 as Grid, Typography } from '@mui/material'

type RecordsTabProps = {
  //
}

export const RecordsTab: React.FC<RecordsTabProps> = () => {
  const { control } = useFormContext()

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography
          variant="body1"
          sx={{
            fontSize: pxToRem(16),
            fontWeight: 500,
            mt: 1,
            mb: 1,
          }}
        >
          Records
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="odometerStart"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Odometer Start"
              placeholder="No odometer readings"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="odometerEnd"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Odometer End"
              placeholder="No odometer readings"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="startedByName"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Started By"
              placeholder="Started By"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="completedByName"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Completed By"
              placeholder="Completed By"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="startedOn"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Started On"
              placeholder="Started On"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Controller
          name="completedOn"
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Completed On"
              placeholder="Completed On"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </Grid>

    </Grid>
  )
}